module.exports = __webpack_public_path__ + "static/media/Kam-min.f7a630ed.PNG";